/**
 * Scroll to top utility
 * Scrolls the window to the top when navigating between pages
 */

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export const scrollToTopInstant = () => {
  window.scrollTo(0, 0);
};
